export default "__VITE_ASSET__s4Bi55MYUqNrp1DXScH0kA__"